import Field from "./_Field";

export default class CheckboxField extends Field
{

  static findAllFieldsInForm(form){
    const inputsEls = form.querySelectorAll('input[type=checkbox]');
    const inputs = {};
    for (let el of inputsEls){
      if (!el.name.endsWith('[]')){
        inputs[ el.name ] = el
      }
    }
    return inputs;
  }

  getValue() {
    return this.el.checked ? true : undefined;
  }

}
